import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "results", "placeholder", "selectButton"]
  static values = {
    fixedPosition: { type: Boolean, default: true }
  }

  connect() {
    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target)) {
        this.hideResults()
      }
    })
  }

  focus() {
    this.showDropdown()
  }

  search(event) {
    const query = event.target.value.toLowerCase()
    this.filterResults(query)
    this.showResults()
  }

  filterResults(query) {
    const buttons = this.resultsTarget.querySelectorAll("button[data-value]")
    let hasMatches = false

    buttons.forEach(button => {
      const code = button.dataset.code.toLowerCase()
      const name = button.dataset.name.toLowerCase()
      const displayText = button.textContent.toLowerCase()

      // Search in code, name, or full display text
      if (code.includes(query) || name.includes(query) || displayText.includes(query)) {
        button.classList.remove("hidden")
        hasMatches = true
      } else {
        button.classList.add("hidden")
      }
    })

    // Show/hide no results message
    const noResultsElement = this.resultsTarget.querySelector('.no-results')
    if (noResultsElement) {
      if (!hasMatches && query) {
        noResultsElement.classList.remove("hidden")
      } else {
        noResultsElement.classList.add("hidden")
      }
    }
  }

  selectVat(event) {
    const vatId = event.currentTarget.dataset.value
    const code = event.currentTarget.dataset.code
    const name = event.currentTarget.dataset.name
    const displayText = `${code} (${name})`

    // Update placeholder text
    this.placeholderTarget.textContent = displayText
    this.placeholderTarget.classList.remove('text-gray-500')
    this.placeholderTarget.classList.add('text-black', 'font-medium')

    this.inputTarget.value = ""

    const hiddenInput = this.element.querySelector('input[type="hidden"]')
    if (hiddenInput) {
      hiddenInput.value = vatId
    }

    this.hideResults()
    // Dispatch native change event on hidden input to trigger form validation
    hiddenInput.dispatchEvent(new Event("change", { bubbles: true }))
  }

  toggleDropdown() {
    if (this.dropdownTarget.classList.contains('hidden')) {
      this.inputTarget.value = ""
      this.filterResults("")
      this.showDropdown()
      this.inputTarget.focus()
    } else {
      this.hideDropdown()
    }
  }

  showResults() {
    this.showDropdown()
  }

  hideResults() {
    this.hideDropdown()
  }

  showDropdown() {
    if (!this.fixedPositionValue) {
      this.dropdownTarget.classList.remove('hidden')
      return
    }

    const triggerRect = this.selectButtonTarget.getBoundingClientRect()
    const dropdownHeight = 280
    const spaceBelow = window.innerHeight - triggerRect.bottom

    // Fixed positioning to escape overflow containers (like lookup-selector)
    const dropdownWidth = Math.max(triggerRect.width, 180)
    const maxLeft = window.innerWidth - dropdownWidth - 8
    this.dropdownTarget.style.position = 'fixed'
    this.dropdownTarget.style.width = `${dropdownWidth}px`
    this.dropdownTarget.style.left = `${Math.min(triggerRect.left, maxLeft)}px`

    if (spaceBelow < dropdownHeight && triggerRect.top > dropdownHeight) {
      this.dropdownTarget.style.top = 'auto'
      this.dropdownTarget.style.bottom = `${window.innerHeight - triggerRect.top + 4}px`
    } else {
      this.dropdownTarget.style.top = `${triggerRect.bottom + 4}px`
      this.dropdownTarget.style.bottom = 'auto'
    }

    this.dropdownTarget.classList.remove('hidden')
  }

  hideDropdown() {
    this.dropdownTarget.classList.add('hidden')
    this.dropdownTarget.style.position = ''
    this.dropdownTarget.style.width = ''
    this.dropdownTarget.style.left = ''
    this.dropdownTarget.style.top = ''
    this.dropdownTarget.style.bottom = ''
  }
}
